<template>
  <div class="outDiv">
    <div class="tabClass">
      <div>
        <span class="oneTitle">{{oneName}}</span>
      </div>
      <div>
        <el-menu
          router
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#409EFF"
        >
          <el-menu-item
            index="baseinfo"
            v-for="(item,index) in tabList"
            :index="item.path"
            :key="item.path"
          >{{item.label}}</el-menu-item>
          <!-- <el-menu-item index="baseinfo">基础信息</el-menu-item>
          <el-menu-item index="ylservice">养老服务</el-menu-item>
          <el-menu-item index="ownaccount">钱包</el-menu-item>
          <el-menu-item index="serviceorder">服务订单</el-menu-item>
          <el-menu-item index="evaluate">评价</el-menu-item>-->
        </el-menu>
      </div>
    </div>
    <div class="allinfochange">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
// import dataApi from "../../_api/api";
import { mapState } from "vuex";
export default {
  data() {
    return {
      activeTap: "",
      activeIndex: "baseinfo",
      tabList: [
        { path: "baseinfo", label: "基础信息" },
        { path: "ownaccount", label: "钱包" },
        { path: "serviceorder", label: "服务订单" },
        { path: "evaluate", label: "评价" },
      ]
    };
  },
  computed: {
    ...mapState(["oneOlder", "olderTap"]),
    oneName() {
      return this.oneOlder.status === 0 ? this.oneOlder.theOldName : this.oneOlder.status === 1 ? `${this.oneOlder.theOldName}(已锁定)` : this.oneOlder.status === 2 ? `${this.oneOlder.theOldName}(已注销)` : "";
    }

  },
  watch: {

  },
  methods: {

  },
  created() {
    this.activeIndex = this.$route.name
  }
};
</script>
<style lang="scss" scoped>
.outDiv {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
  padding: 20px;
  display: flex;
  flex-flow: column;
}
//四级路由 顶部导航栏样式
.tabClass {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #409eff;
  padding-bottom: 10px;
  .oneTitle {
    font-weight: bold;
    font-size: 16px;
  }
}
.allinfochange {
  padding: 0px 0px;
  max-height: calc(100vh - 220px);
  overflow: auto;
}
</style>



